import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { TLocation, TVehicle } from "types";

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Typography from "@mui/material/Typography";

import Location from "./Location";

interface IDealers {
  paperProps?: any;
  vehicle: TVehicle;
  locationId?: number;
  setLocationHandler?: any;
}
const Dealers: React.FC<IDealers> = ({
  paperProps = { sx: { p: 2 } },
  vehicle,
  locationId,
  setLocationHandler,
}): JSX.Element | null => {
  const [value, setValue] = React.useState<any>();
  const { formatMessage: t } = useIntl();

  React.useEffect(() => {
    if (locationId) setValue(locationId.toString());
  }, [locationId]);

  if (!(vehicle.locations && vehicle.locations.length > 0 && locationId)) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent) => {
    if (setLocationHandler) {
      setLocationHandler(event.target.value);
    }
    setValue(parseInt(event.target.value));
  };

  const location = vehicle.locations?.find((e) => e.id === locationId);
  if (!location) return null;

  return (
    <Paper variant="outlined" {...paperProps}>
      <Typography variant="h5" component="h2">
        <FormattedMessage id="common.dealer" defaultMessage="Händlerse" />
      </Typography>
      <Typography sx={{ my: 2 }} variant="body1" component="p">
        Dieses Fahrzeug ist an mehreren Standorten verfügbar. Bitte wählen Sie
        einen bevorzugten aus.
      </Typography>
      <FormControl fullWidth sx={{ my: 1 }}>
        <InputLabel id="demo-simple-select-label">Standort</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          defaultValue={value ? value.toString() : locationId.toString()}
          value={value ? value.toString() : locationId.toString()}
          label="Bitte wählen Sie einen Standort"
          onChange={handleChange}
        >
          {vehicle.locations.map((location: TLocation, ndx) => (
            <MenuItem key={"location-" + location.id} value={location.id}>
              {t({
                id: "location." + location.id + ".name",
                defaultMessage: location.name,
              })}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box>
        <Location location={location} hideName />
      </Box>
    </Paper>
  );
};
export default Dealers;
